import type { Translator } from '@openeducation/oe-it-shared-types';
import axios from 'axios';

import type { Environment } from '../../interfaces';
import { hostsConfig } from '../../utils';

export class TranslatorDao {
  static async getTranslation(
    env: Environment,
    text: string,
    sourceLang: string,
    targetLang: string
  ) {
    const encodedText = encodeURIComponent(text.replace(/[\r\n]+/g, ' '));

    const url = `${hostsConfig[env].thirdpartyService}/v1/tools/translate/${encodedText}/`;
    const { data } = await axios.get<Translator>(url, {
      params: {
        fromLang: sourceLang,
        nativeLang: sourceLang,
        lang: targetLang,
      },
    });

    return data;
  }
}
